export const tabsTranslations = {
  ar: {
    home: 'الرئيسية',
    close: 'إغلاق',
    closeOthers: 'إغلاق الباقي (ما عدا هذه)',
    closeToTheRight: 'إغلاق الذين على اليمين',
    closeToTheLeft: 'إغلاق الذين على اليسار',
    closeAll: 'إغلاق الكل',
    closePage: 'إغلاق الصفحة',
    closeConfirm: 'هل أنت متأكد من رغبتك في إغلاق صفحة "{title}"؟',
    closeConfirmUnsaved: 'صفحة "{title}" تحتوي على بيانات غير محفوظة.\nهل تريد الإغلاق وفقدان هذه التعديلات؟',
    confirmClose: 'إغلاق',
    cancel: 'تراجع',
    fullscreen: 'ملء الشاشة',
    refresh: 'تحديث الصفحة والبيانات',
    limitTitle: 'الحد الأقصى للصفحات المفتوحة',
    limitMessage: 'لا يمكن فتح أكثر من {max} صفحة. لفتح «{title}» أغلق صفحة أولاً.',
    limitPick: 'اختر الصفحة التي تريد إغلاقها، أو أغلق أول صفحة تم فتحها.',
    limitOldest: 'أول صفحة',
    limitCloseOldest: 'إغلاق أول صفحة وفتح الجديدة',
  },
  en: {
    home: 'لوحة التحكم',
    close: 'Close',
    closeOthers: 'Close Others',
    closeToTheRight: 'Close to the Right',
    closeToTheLeft: 'Close to the Left',
    closeAll: 'Close All',
    closePage: 'Close Page',
    closeConfirm: 'Are you sure you want to close "{title}"?',
    closeConfirmUnsaved: '"{title}" has unsaved changes.\nClose and discard them?',
    confirmClose: 'Close',
    cancel: 'Cancel',
    fullscreen: 'Fullscreen',
    refresh: 'Refresh this page and its data',
    limitTitle: 'Maximum open pages',
    limitMessage: 'You can keep at most {max} pages open. Close one to open “{title}”.',
    limitPick: 'Choose a page to close, or close the first page that was opened.',
    limitOldest: 'Oldest',
    limitCloseOldest: 'Close oldest and open new page',
  },
  fr: {
    home: 'Accueil',
    close: 'Fermer',
    closeOthers: 'Fermer les autres',
    closeToTheRight: 'Fermer à droite',
    closeToTheLeft: 'Fermer à gauche',
    closeAll: 'Tout fermer',
    closePage: 'Fermer la page',
    closeConfirm: 'Voulez-vous vraiment fermer « {title} » ?',
    closeConfirmUnsaved: '« {title} » contient des modifications non enregistrées.\nFermer et les abandonner ?',
    confirmClose: 'Fermer',
    cancel: 'Annuler',
    fullscreen: 'Plein écran',
    refresh: 'Actualiser la page et ses données',
    limitTitle: 'Nombre maximum de pages ouvertes',
    limitMessage: 'Vous ne pouvez pas ouvrir plus de {max} pages. Fermez-en une pour ouvrir « {title} ».',
    limitPick: 'Choisissez une page à fermer, ou fermez la première page ouverte.',
    limitOldest: 'Plus ancienne',
    limitCloseOldest: 'Fermer la plus ancienne et ouvrir la nouvelle',
  },
}
